export const Caption = () => {
  return (
    <>
      <section className="caption">
        <div className="_captionWrapper">
          <div className="_capture">
            <article className="_captureText">
              <h1 className="h1BG">
                I build &amp;
                <br />
                Integrate designs
              </h1>

              <p className="text-sm">
                Open source, Real Time Projects have been built over time into
                very simple and reuseable components that scales properly.
                <br />
                Ive done web apps
                <br />
                incorporating frontend into Blockchain Technologies .
              </p>
            </article>

            <a href="#projects" className="_aCapture">
              see my work
              <span></span>
            </a>
          </div>
          <div className="_capture">
            <article className="_captureText">
              <h1 className="h1BG">
                I write,
                <br />
                sometimes
              </h1>

              <p className="text-sm">
                About programming languages, algorithms , Tech careers talks
                ...,
                <br />
                frontend developers roadmap, backend dev roadmap fullstack dev
                roadmap, etc
                <br />
                learning and living.
              </p>
            </article>

            <a href="/" target="_blank" rel="noopener" className="_aCapture">
              read my articles
              <span></span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};
